var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleMaps = function SvgGoogleMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "14.32 4.88 37.856 52.79"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a73e8",
    d: "M37.34 7.82C35.66 7.29 33.86 7 32 7c-5.43 0-10.29 2.45-13.54 6.31l8.35 7.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M18.46 13.31a17.6 17.6 0 0 0-4.14 11.36c0 3.32.66 6.02 1.75 8.43l10.74-12.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M32 17.92a6.764 6.764 0 0 1 5.16 11.13l10.52-12.51a17.68 17.68 0 0 0-10.35-8.71L26.82 20.34A6.74 6.74 0 0 1 32 17.92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "M32 31.44c-3.73 0-6.76-3.03-6.76-6.76a6.7 6.7 0 0 1 1.58-4.34L16.07 33.11c1.84 4.07 4.89 7.34 8.03 11.46l13.06-15.52A6.75 6.75 0 0 1 32 31.44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M36.9 48.8c5.9-9.22 12.77-13.41 12.77-24.13 0-2.94-.72-5.71-1.99-8.15L24.11 44.57c1 1.31 2.01 2.7 2.99 4.24 3.58 5.54 2.59 8.86 4.9 8.86s1.32-3.33 4.9-8.87"
  })));
};
export default SvgGoogleMaps;